import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../common.action';
import ListaLaminasPage from './lista-laminas.page';
import { acessoPermitido } from '../../../../acessos.seguranca';
import WebapiCommon from '../../util/webapi.common';
import RTF from '../../../../componentes/lib/rtf/rtf';
import Format from '../../../../componentes/lib/rtf/format';
import { editorRunat, editorUrl } from '../../../../constants/defaultValues';

class ListaLaminasContainer extends Component {
  constructor() {
    super();
    this.state = {
      laminas: undefined,
    };
  }

  render() {
    return (
      <ListaLaminasPage
        alturaEditor={this.getAltura.bind(this)}
        usuario={this.props.usuario}
        laminas={this.state.laminas}
        obterLaminas={this.obterLaminas.bind(this)}
        altura={this.props.altura}
        acessoPermitido={acessoPermitido}
      />
    );
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);

    WebapiCommon.getListagemLaminas(
      this.props.detalhes.laudo,
      this.props.etapa.etapa
    ).then((listagem) => {
      this.setState({
        laminas: listagem.length === 0 ? undefined : listagem,
      });
      this.props.commonActions.showFadeCarregando(false);
    });
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  };

  obterLaminas() {
    this.props.commonActions.showFadeCarregando(true);
    if (this.props.etapa.etapa === 'IMUNO') {
      WebapiCommon.getTextoLaminaImuno(this.props.detalhes.laudo).then(
        (textos) => {
          this.props.commonActions.showFadeCarregando(false);
          const frame = document.getElementById('iframe-editor');
          textos.forEach((texto) => {
            frame.contentWindow.postMessage(
              {
                method: 'inserirTexto',
                text: btoa(texto),
                type: 'rtf',
                runat: editorRunat,
                breakLine: false,
                paragraph: true,
              },
              editorUrl
            );
          });
        }
      );
    } else {
      WebapiCommon.getTextoLamina(
        this.props.detalhes.laudo,
        this.props.etapa.etapa
      ).then((data) => {
        this.props.commonActions.showFadeCarregando(false);
        const frame = document.getElementById('iframe-editor');
        data.laminas.forEach((lamina) => {
          var myDoc = new RTF();

          var textFormat = new Format();
          textFormat.font = data.fonte;
          textFormat.fontSize = data.tamanhoFonte;
          if (this.props.etapa.etapa === 'CONGELACAO') {
            const date = new Date(lamina.dataCadastro).toLocaleDateString();
            const time = new Date(lamina.dataCadastro).toLocaleTimeString();
            const fullDate = `${date} - ${time}`;

            myDoc.writeText(`Data: ${fullDate}\n`, textFormat);
            myDoc.writeText(`Lamina: ${lamina.lamina}\n`, textFormat);
            lamina.dsComplemento &&
              myDoc.writeText(
                `Complemento: ${lamina.dsComplemento}\n`,
                textFormat
              );
            lamina.bloco &&
              myDoc.writeText(`Bloco: ${lamina.bloco}\n`, textFormat);
            lamina.idNConf &&
              myDoc.writeText(
                `Nao Conformidade: ${lamina.idNConf}\n`,
                textFormat
              );
            myDoc.writeText(`Tecnico: ${lamina.nomeTecnico}\n`, textFormat);
            myDoc.writeText(`Medico: ${lamina.nomeMedico}\n`, textFormat);
            myDoc.writeText(`\n`, textFormat);
          } else {
            myDoc.writeText(`Lamina: ${lamina.nr_Lamina}\n`, textFormat);
          }

          myDoc.createDocument((err, output) => {
            frame.contentWindow.postMessage(
              {
                method: 'inserirTexto',
                text: btoa(output),
                type: 'rtf',
                runat: editorRunat,
                breakLine: false,
                paragraph: true,
              },
              editorUrl
            );
          });
        });
      });
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    etapa: state.commonReducer.etapa,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaLaminasContainer);



// WEBPACK FOOTER //
// ./src/app/common/tabs/listaLaminas/lista-laminas.container.js